{
  "name": "ubiwan-connect",
  "version": "6.11.6",
  "engines": {
    "node": "24.18.0"
  },
  "scripts": {
    "preversion": "git pull --rebase && git fetch origin --prune --prune-tags",
    "postversion": "git push && git push --tags",
    "analyze-bundle": "ng build --configuration=analyze-bundle && source-map-explorer dist/**/*.js --no-border-checks",
    "ng": "ng",
    "dev": "lite-server --baseDir=\"dist/browser\"",
    "start": "ng serve --configuration development --ssl",
    "build": "ng build --configuration production",
    "build:staging": "ng build --configuration staging",
    "lint": "ng lint",
    "test": "jest",
    "test:watch": "jest --watch",
    "prepare": "husky install",
    "report:write": "npm run report:audit && npm run report:outdated",
    "report:send": "node scripts/microsoft-teams/send-reports.mjs",
    "report:audit": "npm audit --json > audit-report.json || true",
    "report:outdated": "npm outdated --json > outdated-report.json || true"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/schematics": "22.0.7",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/animations": "22.0.7",
    "@angular/cli": "22.0.7",
    "@angular/common": "22.0.7",
    "@angular/compiler": "22.0.7",
    "@angular/core": "22.0.7",
    "@angular/forms": "22.0.7",
    "@angular/localize": "22.0.7",
    "@angular/material": "22.0.5",
    "@angular/platform-browser": "22.0.7",
    "@angular/platform-browser-dynamic": "22.0.7",
    "@angular/router": "22.0.7",
    "@angular/service-worker": "22.0.7",
    "@mapbox/polyline": "1.2.1",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@syncfusion/ej2-angular-calendars": "21.1.37",
    "@syncfusion/ej2-angular-dropdowns": "21.1.37",
    "@syncfusion/ej2-angular-grids": "21.1.37",
    "@syncfusion/ej2-angular-navigations": "21.1.37",
    "@syncfusion/ej2-angular-schedule": "21.1.37",
    "@syncfusion/ej2-angular-splitbuttons": "21.1.37",
    "@syncfusion/ej2-cldr-data": "32.1.19",
    "@syncfusion/ej2-material-theme": "21.1.37",
    "@turf/turf": "5.1.6",
    "@types/rbush": "^4.0.0",
    "barcode-detector": "^3.2.2",
    "chart.js": "^4.5.1",
    "chartjs-adapter-luxon": "1.3.1",
    "core-js": "3.49.0",
    "d3": "^7.9.0",
    "dexie": "^4.0.10",
    "driver.js": "1.8.0",
    "jspdf": "^4.1.0",
    "jspdf-autotable": "^5.0.7",
    "jsts": "2.12.1",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "1.13.9",
    "linkify-string": "^4.3.2",
    "linkifyjs": "^4.3.2",
    "lodash-es": "^4.17.21",
    "lodash.clonedeep": "4.5.0",
    "lodash.isequal": "^4.5.0",
    "luxon": "3.7.2",
    "mapbox-gl": "3.18.0",
    "material-design-icons": "3.0.1",
    "md5": "2.3.0",
    "ng2-charts": "^10.0.0",
    "pako": "^3.0.1",
    "posthog-js": "^1.374.2",
    "rbush": "4.0.1",
    "rxjs": "^7.8.2",
    "sass": "1.101.3",
    "source-map": "0.8.0",
    "terraformer-wkt-parser": "1.2.1",
    "tslib": "^2.0.0",
    "uuid": "^14.0.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.0.7",
    "@angular/cdk": "22.0.5",
    "@angular/compiler-cli": "22.0.7",
    "@angular/language-service": "22.0.7",
    "@eslint/js": "^10.0.1",
    "@mapbox/mapbox-gl-draw": "1.5.1",
    "@types/gapi": "0.0.47",
    "@types/gapi.auth2": "0.0.61",
    "@types/geojson": "7946.0.16",
    "@types/jest": "^30.0.0",
    "@types/jsts": "0.17.24",
    "@types/mapbox__mapbox-gl-draw": "1.4.9",
    "@types/mapbox-gl": "3.4.1",
    "@types/node": "^24.0.0",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.7.0",
    "eslint-plugin-sonarjs": "^4.2.0",
    "husky": "^9.1.7",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^17.0.0",
    "lint-staged": "^17.1.1",
    "lite-server": "^2.6.1",
    "ncp": "2.0.0",
    "prettier": "^3.3.2",
    "pretty-quick": "^4.2.2",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.65.0"
  }
}
